<div class="card-body py-3 px-4" [formGroup]="form">
  <div class="search-filter-wrapper d-flex justify-content-between flex-wrap gap-12 mb-3">
    <div class="mr-2">
      <app-grid-server-column-search-filter
        [colDefs]="$any(colDefs)"
        [rowData]="rowData"
        [gridApi]="gridApi"
        [loading]="loading"
      />
    </div>

    <div class="flex-grow-1 hide-empty">
      <ng-content select=".grid-controls-middle"/>
    </div>

    @if (!hideSearch) {
      <div class="search-container d-flex gap-12 flex-shrink-1">
        <app-search-input
          class="search"
          formControlName="search"
          [placeholder]="searchInputPlaceholder"
        />

        <div class="flex-grow-1 hide-empty">
          <ng-content select=".grid-controls-refresh"/>
        </div>

        <app-list-grid-columns-filter
          [colDefs]="detailColDefs.length ? detailColDefs : $any(colDefs)"
          [gridApi]="$any(gridApi)"
          [isRowData]="!!totalRows"
          [loading]="loading"
          (checkboxChange)="onCheckboxChange($any($event))"
          (groupCheckboxChange)="onGroupCheckboxChange($any($event))"
        />

        <div class="flex-shrink-1 hide-empty">
          <ng-content select=".grid-controls-end"/>
        </div>
      </div>
    }
  </div>

  @if (!loading) {
    <ag-grid-angular
      class="custom-ag-grid"
      [class]="themeClass"
      [columnDefs]="$any(colDefs)"
      [gridOptions]="gridOptions"
      [rowSelection]="rowSelection"
      [getRowId]="getRowId"
      [isFullWidthRow]="isFullWidthRow"
      [fullWidthCellRenderer]="fullWidthCellRenderer"
      [rowClassRules]="rowClassRules"
      [getRowHeight]="getRowHeight"
      [statusBar]="statusBar"
      [detailRowAutoHeight]="detailRowAutoHeight"
      [detailCellRenderer]="detailCellRenderer"
      [detailCellRendererParams]="detailCellRendererParams"
      [masterDetail]="masterDetail"
      [defaultExcelExportParams]="defaultExcelExportParams"
      [defaultCsvExportParams]="defaultCsvExportParams"
      [excelStyles]="excelStyles"
      [groupDisplayType]="groupDisplayType"
      [pagination]="pagination"
      [paginationPageSize]="pageSizeService.getPageSize"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [suppressCellFocus]="suppressCellFocus"
      [suppressContextMenu]="suppressContextMenu"
      [domLayout]="domLayout"
      [floatingFiltersHeight]="floatingFiltersHeight"
      [icons]="icons"
      [headerHeight]="headerHeight"
      [suppressMenuHide]="suppressMenuHide"
      [maxBlocksInCache]="maxBlocksInCache"
      [enableAdvancedFilter]="enableAdvancedFilter"
      [cacheBlockSize]="cacheBlockSize"
      [suppressPaginationPanel]="suppressPaginationPanel"
      [suppressScrollOnNewData]="suppressScrollOnNewData"
      [rowModelType]="rowModelType"
      [serverSideDatasource]="serverSideDatasource"
      (selectionChanged)="onSelectionChanged($event)"
      (paginationChanged)="onPaginationChanged($event)"
      (filterChanged)="onFilterChanged($event)"
      (gridReady)="onGridReady($event)"
      (stateUpdated)="onStateUpdated($event)"
    />

    @if (pagination) {
      <app-ag-custom-pagination
        [currentPage]="currentPage"
        [pageNumbers]="pageNumbers"
        [totalPages]="totalPages"
        [paginationPageSize]="pageSizeService.getPageSize"
        [paginationPageSizeSelector]="pageSizeList"
        [showPageSizeSelector]="paginationPageSizeSelector"
        (previousPage)="goToPreviousPage()"
        (nextPage)="goToNextPage()"
        (selectPage)="goToPage($event)"
      />
    }
  } @else {
    <app-loader/>
  }
</div>
